import { Auth, Logger } from "aws-amplify";
import store from "@/store";
import axios from "axios";
import { i18n } from "@/plugins/i18n";

const logger = new Logger("main");
const getToken = async () =>
  (await Auth.currentSession()).getIdToken().getJwtToken();

const getUserByEmail = (email) => {
  //console.log("Nelson getUserByEmail")
  return new Promise((resolve, reject) => {
    let _url = process.env.VUE_APP_CABINET_V2_API_HOST_USER + "/user/list";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };
    axios({ method: "GET", url: _url, headers: _headers })
      .then((result) => {
        // console.log('--- LIST USERS ---')
        // console.log(result)
        let userResult = result.data.user;
        localStorage.setItem("UserData", JSON.stringify(userResult));
        localStorage.setItem("accountType", userResult.accountType);
        console.log(userResult.accountType);
        resolve(userResult);
      })
      .catch((error) => {
        // console.log('--- LIST USERS ---')
        // console.log(error)
        reject(error);
      });
  });
};

// replica
const getUserByEmail_ = (store) => {
  //console.log("Nelson getUserByEmail")
  return new Promise((resolve, reject) => {
    let _url = process.env.VUE_APP_CABINET_V2_API_HOST_USER + "/user/list";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };
    axios({ method: "GET", url: _url, headers: _headers })
      .then((result) => {
        // console.log('--- LIST USERS ---')
        // console.log(result)
        let userResult = result.data.user;
        localStorage.setItem("UserData", JSON.stringify(userResult));
        resolve(userResult);
      })
      .catch((error) => {
        // console.log('--- LIST USERS ---')
        // console.log(error)
        reject(error);
      });
  });
};

const getPreferenceByEmail = (email) => {
  //console.log("Nelson getPreferenceByEmail")
  return new Promise((resolve, reject) => {
    let _url =
      process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES + "/preferences/user";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };
    axios({ method: "GET", url: _url, headers: _headers })
      .then((result) => {
        // console.log('--- PREFERENCES ---')
        let preference = result.data;
        //console.log(preference)
        localStorage.setItem("UserPreference", JSON.stringify(preference.data));
        resolve(preference);
      })
      .catch((error) => {
        // console.log('--- PREFERENCES ---')
        // console.log(error)
        reject(error);
      });
  });
};

const getAccountsByEmail = (email, store) => {
  console.log("Nelson getAccountsByEmail");
  return new Promise((resolve, reject) => {
    if (JSON.parse(localStorage.getItem("storedAccounts")) === null) {
      let _url =
        process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
        "/list/mt4checkdemoaccounts";
      let _headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + store.state.token,
        'X-Api-Key': process.env.VUE_APP_X_API_KEY
      };

      axios({ method: "GET", url: _url, headers: _headers })
        .then((result) => {
          if (result.data.response.status == "Success") {
            localStorage.setItem(
              "DemoAccounts",
              JSON.stringify(result.data.response.data)
            );
            resolve(result.data.response.data);
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          logger.error(error);
          reject(error);
        });
    } else {
      resolve(null);
    }
  });
};

const getAccountsMt5ByEmail = (email, store) => {
  console.log("Nelson getAccountsMt5ByEmail");
  return new Promise((resolve, reject) => {
    let _url =
      process.env.VUE_APP_CABINET_V2_API_HOST_USER + "/list/mt5checkaccounts";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };

    axios({ method: "GET", url: _url, headers: _headers })
      .then((result) => {
        if (result.data.message.status == "Success") {
          localStorage.setItem(
            "storedAccountsmt5",
            JSON.stringify(result.data.message.data)
          );
          resolve(result.data.message.data);
        } else {
          localStorage.setItem("storedAccountsmt5", null);
          resolve(null);
          if (result.data.message.status == 1) {
            alert(result.data.message.msg);
          }
        }
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};

const getApplicationsByEmail = (email, applicationID) => {
  console.log("Nelson getApplicationsByEmail");
  return new Promise((resolve, reject) => {
    let _url = process.env.VUE_APP_CABINET_V2_API_HOST_PROCESS + "/forms/list";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };
    axios({ method: "GET", url: _url, data: {}, headers: _headers })
      .then((result) => {
        // console.log('--- APPLICATION RESULTS ---')
        //console.log(result)

        let items = result.data.data;
        if (items !== null) {
          resolve(items);
          /*items.forEach((application) => {
                    // validation of applicationID removed because isn't needed for Demo accounts
                    // 2023-04-26 by Deblyn, DanielP and Nelson
                    if (application.id)
                        resolve(application)
                })*/
          // reject('target application with id ' + applicationID + ' was not found')
        } else {
          logger.error("ERROR: No application items");
          reject("ERROR: No application items");
        }
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};
//This function create preferences - method POST
const initializePreferences = (email) => {
  console.log("Nelson initializePreferences");
  //INSERT INTO PREFERENCES
  return new Promise((resolve, reject) => {
    let _url =
      process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES + "/preferences/user";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };
    let _data = {
      theme: "LIGHT",
      dashboardLanguage: "EN",
      emailsLanguage: "EN",
      subscribedToCompanyNews: false,
      subscribedToTradingNews: false,
    };
    console.log("--- LENGUAJE YYY ---");
    //console.log(emailsLanguage)
    axios({ method: "POST", url: _url, data: _data, headers: _headers })
      .then((result) => {
        console.log("--- PREFERENCE ---");
        console.log(result);
        let data = result.data;
        let preference = data.preference;
        resolve(preference);
      })
      .catch((error) => {
        console.log("--- PREFERENCE ---");
        console.log(error);
        reject(error);
      });
  });
};
const registerUserBasicStep = (email) => {
  console.log("Nelson registerUserBasicStep");
  //INSERT INTO DATA BASE
  return new Promise((resolve, reject) => {
    let _url = process.env.VUE_APP_CABINET_V2_API_HOST_USER + "/user/basic";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };

    axios({ method: "POST", url: _url, headers: _headers })
      .then((result) => {
        console.log("--- BASIC USER REGISTRY ---");
        let data = result.data;
        let user = data.user;
        resolve(user);
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};

// formulario application proccess
const application_form = () => {
  //INSERT INTO DATA BASE
  return new Promise((resolve, reject) => {
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };
    axios({
      method: "GET",
      url: process.env.VUE_APP_CABINET_V2_API_HOST_PROCESS + "/forms/structure",
      headers: _headers,
    })
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};

// Traer preferencias del sito (Métodos de pago)
const getPreferencesSite = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: "GET",
      url:
        process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES +
        "/preferences/site",
    })
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};

// mt4 live accounts
const accountslv4 = () => {
  return new Promise((resolve, reject) => {
    let _url =
      process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
      "/list/mt4checkaccounts";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };

    axios({ method: "GET", url: _url, headers: _headers })
      .then((result) => {
        if (result.data.response.status == "Success") {
          resolve(result.data.response.data);
        }
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};

// mt5 live accounts
const accountslv5 = () => {
  return new Promise((resolve, reject) => {
    let _url =
      process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
      "/list/mt5checkaccounts";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };

    axios({ method: "GET", url: _url, headers: _headers })
      .then((result) => {
        if (result.data.response.status == "Success") {
          resolve(result.data.response.data);
        }
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};

//mt4 demo accounts
const accountsDm4 = () => {
  return new Promise((resolve, reject) => {
    let _url =
      process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
      "/list/mt4checkdemoaccounts";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };

    axios({ method: "GET", url: _url, headers: _headers })
      .then((result) => {
        if (result.data.response.status == "Success") {
          resolve(result.data.response.data);
        }
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};

//mt5 demo accounts
const accountsDm5 = () => {
  return new Promise((resolve, reject) => {
    let _url =
      process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
      "/list/mt5checkdemoaccounts";
    let _headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + store.state.token,
      'X-Api-Key': process.env.VUE_APP_X_API_KEY
    };

    axios({ method: "GET", url: _url, headers: _headers })
      .then((result) => {
        if (result.data.response.status == "Success") {
          resolve(result.data.response.data);
        }
      })
      .catch((error) => {
        logger.error(error);
        reject(error);
      });
  });
};

function translateText(platform_name, translationMap) {
  console.log(translationMap.hasOwnProperty(platform_name))
  if (translationMap.hasOwnProperty(platform_name)) {    
    const translation = i18n.global.t(translationMap[platform_name]);
    return translation;
  } else {
    console.log(`No translation found for ${platform_name}`);
    return platform_name;
  }
}

export {
  getAccountsByEmail,
  getUserByEmail,
  getPreferenceByEmail,
  getApplicationsByEmail,
  initializePreferences,
  registerUserBasicStep,
  getAccountsMt5ByEmail,
  application_form,
  getPreferencesSite,
  accountslv4,
  accountsDm4,
  accountsDm5,
  accountslv5,
  getUserByEmail_,
  translateText,
};
